export enum loginForms {
    unknown = 0,
    list = 1,
    noUserMfaForApp = 2,
    selected = 3,
    twoFactorOtp = 4,
    twoFactorPush = 5,
    twoFactorU2F = 6,
    twoFactorUnsupported = 7,
    verifiedList = 8,
    twoFactorList = 9,
    elevate = 10,
    resetPasswordValidate = 11,
    credsKaseyaOne = 13
}
